import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Exact } from "@Helpers/types/exact";

type MinimizerItem = {
  path: string;
  text: string;
  index?: number;
};

const minimizeFloatterSlice = createSlice({
  name: "minimizeFloatterData",
  initialState: [] as MinimizerItem[],
  reducers: {
    setMinimizerData: (state, action: PayloadAction<MinimizerItem>) => {
      const checkForExistingEntry = state.find((item: any) => item.path == action.payload.path);
      if (!checkForExistingEntry) {
        const data = [...state, action.payload];
        return data.map((item: any, index: any) => ({
          ...item,
          index,
        }));
      }
      return state;
    },
    removeMinimizerData: (state, action: PayloadAction<number>) => {
      const data = [...state];
      data.splice(action.payload, 1);
      const result = data.map((record: any, index: any) => ({ ...record, index }));
      return result;
    },
    emptyMinimizerData: () => [],
  },
});

const {
  setMinimizerData: _setMinimizerDataRaw,
  removeMinimizerData,
  emptyMinimizerData,
} = minimizeFloatterSlice.actions;

/** Exact<>-wrapped: object payload, catches excess properties via variables. */
export const setMinimizerData = <T extends Exact<MinimizerItem, T>>(payload: T) => _setMinimizerDataRaw(payload);
export { removeMinimizerData, emptyMinimizerData };

export const minimizeFloatterData = minimizeFloatterSlice.reducer;

export default minimizeFloatterSlice.reducer;
